import React from 'react';
import { RadixIconName } from '@/database/types';
import * as Icons from '@radix-ui/react-icons';

interface DynamicIconProps {
  name: RadixIconName;
  width?: string | number;
  height?: string | number;
}

export const DynamicIcon: React.FC<DynamicIconProps> = ({
  name,
  width = 16,
  height = 16,
}) => {
  const IconComponent = Icons[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" does not exist in Radix Icons.`);
    return <Icons.QuestionMarkIcon width={width} height={height} />;
  }

  return <IconComponent width={width} height={height} />;
};
